import { forkJoin, Subject } from 'rxjs';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, Params } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

import {MatDialog as MatDialog,MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { PagesService } from './pages.service';
import { debounceTime, map, take } from 'rxjs/operators';
import { SiteMenuService } from 'src/app/site-menu/site-menu/common/services/site-menu.service';
import { SecurityComponent } from 'src/app/views/security/security.component';
import { param } from 'jquery';
import { PagesSlugsComponent } from 'src/app/site-menu/pages-slugs/pages-slugs.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit {

  ischecked: boolean = false;
  catId: number;
  checkAllTrades: boolean = false;
  selected: boolean = false;
  selectedPages: any[] = [];
  archivedPages: any[] = [];
  activePages: any[] = [];
  searchText = ""
  showCheckbox: boolean = false;
  isEditEnabled = false;
  allSelected = false;
  assigned: any[] = [];
  allPages: any[] = [];
  activePage:any
  constructor(
     private snotifyService: ToastrService,
    public pagesService: PagesService,
    private httpClient: HttpClient,
    private dialog: MatDialog,

  ) { }

  site: any = {};
  showarchivedPages: boolean = false;
  subject: Subject<any> = new Subject();
  filterResultsCategory = null;
  filterResultsSlug = '';
  filterResultsSearchText = '';
  pageParams = {
    "pageName": "",
    "status": 0,
    "pageCategory": 0,
    "cultureId": 0,
    "cultureCode": "",
    "pageNumber": 0,
    "pageSize": 10,
    "searchText": ""
  }

  ngOnInit() {
    // this.pagesService.getAll().subscribe();
    this.getPages(true);


    this.subject.pipe(debounceTime(500)).subscribe(() => {
      this.getPages();
    });

  }
  public applyFilter() {
    this.subject.next(true);
  }
  getPages(isFirstTime?) {
    let api = [
      this.pagesService.getActivePages(this.pageParams),
      this.pagesService.getArchivePages(this.pageParams)
    ];
    if (!isFirstTime) {
      if (!this.showarchivedPages) {
        api.pop();
      }
      if (this.showarchivedPages) {
        api.shift();
      }
    }

    forkJoin(api).subscribe(res => console.log('pages list', res));
  }

  togglePages() {
    this.pageParams.pageSize = 10;
    this.pageParams.pageNumber = 0;
    this.pageParams.searchText = "";
    this.showarchivedPages = !this.showarchivedPages;
    this.selectedPages = [];
    this.getPages();

  }

  enableEdit() {
    this.isEditEnabled = !this.isEditEnabled;
    this.selectedPages = [];
  }

  toggleCheckBox(id) {
    const index = this.selectedPages.findIndex(x => x === id);
    if (index >= 0) {
      this.selectedPages.splice(index, 1)
    }
    else {
      this.selectedPages.push(id)
    }
  }

  isPageSelected(parentId) {
    return this.selectedPages.indexOf(parentId) >= 0;
  }

  toggleAll(event) {
    if (event.target.checked) {
      this.pagesService.pages$.pipe(take(1))
        .subscribe(
          arr => this.selectedPages = arr['pages'].filter(x =>
            this.showarchivedPages ? x.pageStatus === 4 : x.pageStatus !== 4).map(x => x.parentPageId)
        )
    }
    else {
      this.selectedPages = [];
    }
  }

  editPageStatus(newStatus, parentId , oldPage?) {
    let pages;
    if(oldPage ==4 && newStatus==2)
    this.pagesService.archivedPages$.pipe(take(1)).subscribe(p => pages = p)
    else if ( newStatus == 3 || (newStatus == 2 && oldPage==0))
     this.pagesService.archivedPages$.pipe(take(1)).subscribe(p => pages = p)
  
     else
      this.pagesService.pages$.pipe(take(1)).subscribe(p => pages = p);

   // this.pagesService.pages$.pipe(take(1)).subscribe(p => {
    //   
    //   pages = p
    // });
    const target = pages.pages.find(x => x.parentPageId === parentId);
    const array = target.pageCultureDetails.map(culture => culture.pageId);
    target.pageStatus = newStatus;

    this.submitUpdateStatus(array, newStatus, pages, parentId, true);
  }

  updateManyPagesStatus(newStatus: number ,  oldPage?) {

    let pages;
    let array = [];
   // newStatus == 3 || newStatus == 2  ? this.pagesService.archivedPages$.pipe(take(1)).subscribe(p => pages = p) : this.pagesService.pages$.pipe(take(1)).subscribe(p => pages = p);

  //  this.pagesService.pages$.pipe(take(1)).subscribe(p => pages = p);

  if(oldPage ==4 && newStatus==2)
  this.pagesService.archivedPages$.pipe(take(1)).subscribe(p => pages = p)
  else if ( newStatus == 3 || (newStatus == 2 && oldPage==0))
   this.pagesService.archivedPages$.pipe(take(1)).subscribe(p => pages = p)
   else
    this.pagesService.pages$.pipe(take(1)).subscribe(p => pages = p);

    for (let parentId of this.selectedPages) {
      const target = pages.pages.find(x => x.parentPageId === parentId);
      const ids = target.pageCultureDetails.map(culture => culture.pageId);
      array = array.concat(ids);

      target.pageStatus = newStatus;
    }

    this.submitUpdateStatus(array, newStatus, pages);
  }
  msg: string;
  submitUpdateStatus(array, newStatus, pages, parentId?, getPages?) {
    pages = pages.pages;
    if(newStatus == 3)
    {this.msg = "Pages Deleted"  }
    else if (newStatus == 4)
    {this.msg = "Moved To Archived"}
    else if (newStatus == 2)
    {this.msg = "Updated"}
    else if (newStatus == 5)
    {this.msg = "Updated Remove required login Successfuly"}
    else if (newStatus == 6)
    {this.msg = "Updated required login Successfuly"}
    else
    {this.msg="Updated Succefuly"}
  //  newStatus === 4 ? this.msg = "Pages Deleted" :  this.msg = 'Updated Successfully'
    this.pagesService.editPageStatus(array.join(','), newStatus)
      .subscribe(
        res => {
          if (parentId) {
            const targetPageIndex = pages.findIndex(x => x.parentPageId === parentId);

            for (let culture of pages[targetPageIndex].pageCultureDetails) {
              culture.pageCultureStatus = newStatus;
            }

            if (getPages) {
              this.getPages();
            }
          }
          // this.pagesService.pagesSubject.next(pages);
          this.getPages();
          this.snotifyService.success('', this.msg, {
            timeOut: 2000,
            progressBar: true,
            tapToDismiss: true,
          })
          this.selectedPages=[]

        },
        err => {
          this.snotifyService.error('Error while deleting the page')
        }
      )


  }


  setPageAsDefault(parentId: string) {
    this.httpClient.post(`/Sites/SetDefaultPage`, { parentId })
      .subscribe(
        res => {

          this.getPages()


          // this.activePage.parentId=parentId


          // this.pagesService.pages$.pipe(
          //   take(1),
          //   map((array) =>{
          //     return {...array,pages:array.pages.map((page) => ({ ...page, isDefaultPage: false }))}})
          // )
          //   .subscribe(
          //     arr => {


          //       const index = arr.pages.findIndex(page => page.parentPageId == parentId);
          //       arr.pages[index].isDefaultPage = true;

          //       this.pagesService.pagesSubject.next(arr)
          //     }
          //   )
        }
      )
  }

  singleCheckbox(event, pages: any[]) {
    if (event.target.checked == true) {
      this.ischecked = true
    }

    if (this.ischecked && this.checkAllTrades) {
      event.target.checked = true
    }

    this.selectedPages.push(pages)
  }

  GetAllDeletedPages() {
    this.httpClient.get(`/Pages/GetAllPages/0/3`).subscribe((res: any) => {
      this.archivedPages = res;
    });
  }

  // getTotal(pages: any[], isArchived: boolean) {
  //   if (!pages) { return; }
  //   if (isArchived) {
  //     return pages.filter(x => x.pageStatus == 4).length
  //   } else {
  //     return pages.filter(x => x.pageStatus != 4).length
  //   }
  // }

  updateSecurity(page) {

    console.log('page Test !!!!!!!!!');

    console.log(page);

    this.pagesService.getAssignedRoles(page.parentPageId)
      .subscribe(
        (res: any) => {
          console.log('assingedRoles @@@@@@@@@@@@');

          console.log(res.unassingedRoles);

          let dialogRef = this.dialog.open(
            SecurityComponent,
            {
              width: '70vw',
              data: {

                unAssigendRole: res.unassingedRoles,
                assigendRoles: res.assingedRoles
              }
            });
          dialogRef.afterClosed()
            .subscribe(
              (result) => {
                if (result) {
                  console.log('result');

                  console.log(result);

                  let rolesAndAsigend: any = {
                    'id': page.parentPageId,
                    'unassingedRoles': result.unAssigendRole,
                    'assingedRoles': result.assigendRoles
                  };

                  this.pagesService.updateAssignedRoles(rolesAndAsigend)
                    .subscribe(
                      res => {
                        console.log(res ,'res of updateAssignedRoles ##########');
                        
                        this.snotifyService.success('Roles updated successfully')
                      }
                    )
                }
              }
            )
        }
      )
  }

  changePage(event) {
    this.pageParams.pageSize = event.itemsPerPage;
    this.pageParams.pageNumber = event.page - 1;
    this.getPages();
  }

  openPagesDialog(source: string, editSelectedItem: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '50vw';
    dialogConfig.data = { source };
    let modalRef;

    modalRef = this.dialog.open(PagesSlugsComponent, dialogConfig)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.updateRequiredLoginPages(res.parentId);
          console.log('modal result', res)
        }
      })
  }

  updateRequiredLoginPages(selectedParentLoginId) {

  //   {
  //     "slugTargetId": 5,
  //     "slug": "pq",
  //     "parentId": 3
  // }

  console.log('selected pages', this.selectedPages);

  this.pagesService.updaterequiredLogin(this.selectedPages, selectedParentLoginId)
  .subscribe(res => {

    this.getPages();
    this.snotifyService.success('', 'Update Required Login for selected pages', {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    })
    this.selectedPages=[]
  },
  err => {
    this.snotifyService.error('Error while selected login page')
  })
    
  }

  removeRequiredLoginPages() {
    console.log('this.selectedPages', this.selectedPages);
    
    this.pagesService.updaterequiredLogin(this.selectedPages, null)
      .subscribe(res => {

      this.getPages();
      this.snotifyService.success('', 'Remove Required Login for Selected Pages', {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      })
      this.selectedPages=[]
      },
      err => {
        this.snotifyService.error('Error while selected login page')
      })
  }


}
